import {creativeTemplatesApi} from 'common/src/modules/creativeTemplates/creativeTemplates.api';
import {DPLayerMapping, DPMeta} from 'common/src/modules/dynamicParameters/dynamicParameters.types';
import fillNoMappingWithEmpty from 'common/src/modules/creativeTemplates/utils/fillNoMappingWithEmpty';

export interface FormatMetadataResult {
  templateMeta: Record<string, DPMeta>;
  templateMapping: Record<string, DPLayerMapping[]>;
  originalMapping: Record<string, DPLayerMapping[]>;
  metadataResults: {meta: DPMeta; mapping: DPLayerMapping[]}[];
}

export default async function fetchFormatMetadata(
  templateId: number,
  formatKeys: string[],
  isJetMapping: boolean,
): Promise<FormatMetadataResult> {
  // Fetch metadata for each format
  const metadataPromises = formatKeys.map((format) =>
    creativeTemplatesApi.getFormatMapping(templateId, format, isJetMapping),
  );

  const metadataResults = await Promise.all(metadataPromises);

  // Build templateMeta and templateMapping objects using fillNoMappingWithEmpty
  const templateMeta: Record<string, DPMeta> = {};
  const templateMapping: Record<string, DPLayerMapping[]> = {};
  const originalMapping: Record<string, DPLayerMapping[]> = {};

  formatKeys.forEach((format, index) => {
    templateMeta[format] = metadataResults[index].meta;
    const processedMapping = fillNoMappingWithEmpty(
      metadataResults[index].meta,
      metadataResults[index].mapping,
    );
    templateMapping[format] = processedMapping;
    originalMapping[format] = processedMapping;
  });

  return {
    templateMeta,
    templateMapping,
    originalMapping,
    metadataResults,
  };
}
